<div class="portfolio">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 text-center">
                <h1>My Projects</h1>
                <p>Una muestra de proyectos que llevo a cabo en mi tiempo libre con nuevas tecnolog&iacute;as.</p>
            </div>
        </div>
        <div class="row">
            <mat-card class="card mx-auto my-2" *ngFor="let proyect of portfolio">
                <mat-card-header>
                    <mat-card-title>{{ proyect.name }}</mat-card-title>
                    <mat-card-subtitle></mat-card-subtitle>
                </mat-card-header>
                <img mat-card-image [src]="proyect.imageUrl" [alt]="proyect.name">
                <mat-card-content>
                    <p>{{proyect.description}}</p>
                    <h5>Tecnologias aplicadas</h5>
                    <span class="badge badge-primary mx-1" *ngFor="let lang of proyect.lenguajes">{{lang.name}}
                        {{lang.version}}</span>
                    <br>
                    <span class="badge badge-success mx-1" *ngFor="let frame of proyect.frameworks">{{frame.name}}
                        {{frame.version}}</span>
                </mat-card-content>
                <mat-card-actions class="actions">
                    <a [href]="proyect.url" target="_blank">VISITAR</a>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>